// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2OtKg","head":"Table_head__3AD5o","col":"Table_col__Oxqcx"};